import { useQuery } from '@tanstack/react-query';

import { QueryKey } from '@/config/query-client';
import { fetchAccount } from '@/api/v4/account.api';

export const useAccount = (accountId?: string) => {
  const getAccount = () => {
    if (!accountId) return;

    return fetchAccount(accountId);
  };

  return useQuery({
    queryKey: [QueryKey.Account, accountId],
    queryFn: getAccount,
    gcTime: Infinity,
    staleTime: Infinity,
    enabled: !!accountId,
  });
};
